import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'now-wbsuche-app-back-to-top-button',
  templateUrl: './back-to-top-button.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BackToTopButtonComponent {}
